/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import formatMessage from '../../format-message';
import '../tinymce/ko_KR';
const locale = {
  "access_the_pretty_html_editor_37168efe": {
    "message": "Pretty HTML 편집기에 액세스"
  },
  "accessibility_checker_b3af1f6c": {
    "message": "접근성 확인 기능"
  },
  "action_to_take_b626a99a": {
    "message": "실행할 작업:"
  },
  "add_8523c19b": {
    "message": "추가"
  },
  "add_a_caption_2a915239": {
    "message": "캡션 추가"
  },
  "add_alt_text_for_the_image_48cd88aa": {
    "message": "이미지의 대체 텍스트 추가"
  },
  "add_another_f4e50d57": {
    "message": "다른 항목 추가"
  },
  "add_cc_subtitles_55f0394e": {
    "message": "CC/자막 추가"
  },
  "add_image_60b2de07": {
    "message": "이미지 추가"
  },
  "add_one_9e34a6f8": {
    "message": "추가하기!"
  },
  "additional_considerations_f3801683": {
    "message": "추가 고려 사항"
  },
  "address_applied_64269b0b": {
    "message": "주소 적용됨"
  },
  "address_removed_fcb496e0": {
    "message": "주소 제거됨"
  },
  "adjacent_links_with_the_same_url_should_be_a_singl_7a1f7f6c": {
    "message": "같은 URL의 인접한 링크는 하나의 링크여야 합니다."
  },
  "aleph_f4ffd155": {
    "message": "알레프"
  },
  "align_11050992": {
    "message": "정렬"
  },
  "alignment_and_lists_5cebcb69": {
    "message": "정렬 및 목록"
  },
  "all_4321c3a1": {
    "message": "전체"
  },
  "all_apps_a50dea49": {
    "message": "모든 앱"
  },
  "allow_media_download_16dcf2bd": {
    "message": "미디어 다운로드 허용"
  },
  "allow_transcript_download_3fa239f0": {
    "message": "대화 기록 다운로드 허용"
  },
  "alpha_15d59033": {
    "message": "알파"
  },
  "alphabetical_55b5b4e0": {
    "message": "영문자순"
  },
  "alt_attribute_text_should_not_contain_more_than_12_e21d4040": {
    "message": "대체 특성 텍스트는 120자 이상을 포함할 수 없습니다."
  },
  "alt_text_611fb322": {
    "message": "대체 텍스트"
  },
  "amalg_coproduct_c589fb12": {
    "message": "융합(쌍대곱)"
  },
  "an_error_occured_reading_the_file_ff48558b": {
    "message": "파일을 읽는 데 오류가 발생했습니다"
  },
  "an_error_occurred_making_a_network_request_d1bda348": {
    "message": "네트워크 요청을 만드는 데 오류가 발생했습니다"
  },
  "an_error_occurred_uploading_your_media_71f1444d": {
    "message": "미디어를 업로드하는 데 오류가 발생했습니다."
  },
  "and_7fcc2911": {
    "message": "및"
  },
  "angle_c5b4ec50": {
    "message": "각도"
  },
  "announcement_fb4cb645": {
    "message": "공지"
  },
  "announcement_list_da155734": {
    "message": "공지 목록"
  },
  "announcements_a4b8ed4a": {
    "message": "공지"
  },
  "apply_781a2546": {
    "message": "적용"
  },
  "apply_changes_to_all_instances_of_this_icon_maker__2642f466": {
    "message": "과목에서 이 아이콘 메이커 아이콘의 모든 인스턴스에 변경 사항을 적용"
  },
  "approaches_the_limit_893aeec9": {
    "message": "한도에 근접"
  },
  "approximately_e7965800": {
    "message": "대략"
  },
  "apps_54d24a47": {
    "message": "앱"
  },
  "are_you_sure_you_want_to_cancel_changes_you_made_m_c5210496": {
    "message": "취소하시겠습니까? 변경한 사항은 저장되지 않을 수 있습니다."
  },
  "arrows_464a3e54": {
    "message": "화살표"
  },
  "art_icon_8e1daad": {
    "message": "미술 아이콘"
  },
  "aspect_ratio_will_be_preserved_cb5fdfb8": {
    "message": "비율을 유지"
  },
  "assignment_976578a8": {
    "message": "과제"
  },
  "assignments_1e02582c": {
    "message": "과제"
  },
  "asterisk_82255584": {
    "message": "별표"
  },
  "attributes_963ba262": {
    "message": "속성"
  },
  "audio_and_video_recording_not_supported_please_use_5ce3f0d7": {
    "message": "오디오 및 동영상 녹음/녹화를 지원하지 않습니다. 다른 브라우저를 사용하세요."
  },
  "audio_options_feb58e2c": {
    "message": "오디오 옵션"
  },
  "audio_options_tray_33a90711": {
    "message": "오디오 옵션 트레이"
  },
  "audio_player_for_title_20cc70d": {
    "message": "{ title }의 오디오 플레이어"
  },
  "auto_saved_content_exists_would_you_like_to_load_t_fee528f2": {
    "message": "자동 저장된 콘텐츠가 있습니다. 대신에 자동 저장된 콘텐츠를 로드하시겠습니까?"
  },
  "available_folders_694d0436": {
    "message": "사용 가능한 폴더"
  },
  "background_1bc88842": {
    "message": "배경"
  },
  "backslash_b2d5442d": {
    "message": "백슬래시"
  },
  "bar_ec63ed6": {
    "message": "막대"
  },
  "basic_554cdc0a": {
    "message": "기본"
  },
  "because_501841b": {
    "message": "이유"
  },
  "below_81d4dceb": {
    "message": "아래"
  },
  "beta_cb5f307e": {
    "message": "베타"
  },
  "big_circle_16b2e604": {
    "message": "큰 원"
  },
  "binomial_coefficient_ea5b9bb7": {
    "message": "이항 계수"
  },
  "black_4cb01371": {
    "message": "검정"
  },
  "blue_daf8fea9": {
    "message": "파랑"
  },
  "bold_applied_42d547b7": {
    "message": "굵은 글꼴 적용됨"
  },
  "bold_removed_da474a5c": {
    "message": "굵은 글꼴 제거됨"
  },
  "border_5b08b06d": {
    "message": "경계"
  },
  "bottom_15a2a9be": {
    "message": "아래"
  },
  "bottom_third_5f5fec1d": {
    "message": "아래 3분위"
  },
  "bowtie_5f9629e4": {
    "message": "나비 넥타이"
  },
  "brick_f2656265": {
    "message": "벽돌"
  },
  "c_2001_acme_inc_283f7f80": {
    "message": "(c) 2001 Acme Inc."
  },
  "cancel_caeb1e68": {
    "message": "취소"
  },
  "cap_product_3a5265a6": {
    "message": "교집합"
  },
  "caption_manager_aae0906f": {
    "message": "캡션 매니저"
  },
  "center_align_e68d9997": {
    "message": "가운데 정렬"
  },
  "centered_dot_64d5e378": {
    "message": "가운데 점"
  },
  "centered_horizontal_dots_451c5815": {
    "message": "가운데 수평 점"
  },
  "change_alt_text_92654906": {
    "message": "대체 텍스트 변경"
  },
  "change_heading_tag_to_paragraph_a61e3113": {
    "message": "머리글 태그를 문단으로 변경"
  },
  "change_only_this_heading_s_level_903cc956": {
    "message": "이 머리글의 수준만 변경"
  },
  "change_text_color_1aecb912": {
    "message": "텍스트 색 변경"
  },
  "changes_will_apply_after_you_save_this_page_fb324e9d": {
    "message": "이 페이지를 저장한 후에 변경 사항이 적용됩니다."
  },
  "changes_you_made_may_not_be_saved_4e8db973": {
    "message": "변경한 사항은 저장되지 않을 수 있습니다."
  },
  "characters_9d897d1c": {
    "message": "문자"
  },
  "characters_no_spaces_485e5367": {
    "message": "문자(공백 없음)"
  },
  "check_accessibility_3c78211c": {
    "message": "접근성 확인"
  },
  "checking_for_accessibility_issues_fac18c6d": {
    "message": "접근성 문제 확인"
  },
  "chi_54a32644": {
    "message": "Chi"
  },
  "choose_caption_file_9c45bc4e": {
    "message": "캡션 파일 선택"
  },
  "choose_usage_rights_33683854": {
    "message": "사용 권리를 선택..."
  },
  "circle_484abe63": {
    "message": "원"
  },
  "circle_unordered_list_9e3a0763": {
    "message": "원 순서가 지정되지 않은 목록"
  },
  "clear_2084585f": {
    "message": "지우기"
  },
  "clear_image_3213fe62": {
    "message": "이미지 지우기"
  },
  "click_or_shift_click_for_the_html_editor_25d70bb4": {
    "message": "클릭하거나 HTML 편집기는 Shift를 누르고 클릭합니다."
  },
  "click_to_embed_imagename_c41ea8df": {
    "message": "클릭하여 { imageName } 포함"
  },
  "click_to_hide_preview_3c707763": {
    "message": "클릭하여 미리 보기 숨기기"
  },
  "click_to_insert_a_link_into_the_editor_c19613aa": {
    "message": "클릭하여 편집기에 링크를 삽입합니다."
  },
  "click_to_show_preview_faa27051": {
    "message": "클릭하여 미리 보기 표시"
  },
  "close_a_menu_or_dialog_also_returns_you_to_the_edi_739079e6": {
    "message": "메뉴 또는 대화 상자를 닫습니다. 또한 편집기 영역으로 돌아가기"
  },
  "close_accessibility_checker_29d1c51e": {
    "message": "접근성 확인 기능 닫기"
  },
  "close_d634289d": {
    "message": "닫기"
  },
  "close_keyboard_shortcuts_modal_291ce074": {
    "message": "키보드 바로 가기 키 모달 닫기"
  },
  "closed_caption_file_must_be_less_than_maxkb_kb_5880f752": {
    "message": "자막 파일은 { maxKb }kb 미만이어야 합니다"
  },
  "closed_captions_subtitles_e6aaa016": {
    "message": "캡션/자막"
  },
  "clubs_suit_c1ffedff": {
    "message": "클럽(슈트)"
  },
  "collab_575ac7bc": {
    "message": "공동 작업"
  },
  "collaborations_5c56c15f": {
    "message": "공동 작업"
  },
  "collapse_to_hide_types_1ab46d2e": {
    "message": "접어서 { types } 숨기기"
  },
  "color_a363e1b0": {
    "message": "색"
  },
  "color_contrast_4c418add": {
    "message": "색 대비"
  },
  "color_contrast_ratio_687782f0": {
    "message": "색 대비 비율"
  },
  "color_picker_6b359edf": {
    "message": "색 선택기"
  },
  "color_picker_colorname_selected_ad4cf400": {
    "message": "색 선택기({ colorName } 선택됨)"
  },
  "color_popup_af39810f": {
    "message": "색 팝업"
  },
  "column_e1ae5c64": {
    "message": "열"
  },
  "column_group_1c062368": {
    "message": "열 그룹"
  },
  "complex_numbers_a543d004": {
    "message": "복소수"
  },
  "computer_1d7dfa6f": {
    "message": "컴퓨터"
  },
  "congruent_5a244acd": {
    "message": "합동"
  },
  "contains_311f37b7": {
    "message": "포함"
  },
  "content_1440204b": {
    "message": "콘텐츠"
  },
  "content_in_the_editor_will_be_changed_press_cancel_d5bf3357": {
    "message": "편집기에 콘텐츠를 변경합니다. 취소를 눌러서 원래 콘텐츠를 유지합니다."
  },
  "content_is_still_being_uploaded_if_you_continue_it_8f06d0cb": {
    "message": "콘텐츠를 아직 업로드 중입니다. 계속하는 경우 적절하게 포함되지 않을 것입니다."
  },
  "content_subtype_5ce35e88": {
    "message": "콘텐츠 하위 유형"
  },
  "content_type_2cf90d95": {
    "message": "콘텐츠 유형"
  },
  "continue_to_youtube_content_a34f0f85": {
    "message": "YouTube 콘텐츠로 계속하기"
  },
  "coproduct_e7838082": {
    "message": "쌍대곱"
  },
  "copyright_holder_66ee111": {
    "message": "저작권 보유자:"
  },
  "could_not_insert_content_itemtype_items_are_not_cu_638dfecd": {
    "message": "콘텐츠를 삽입할 수 없음: ‘{ itemType }‘ 항목은 현재 Canvas에서 지원하지 않습니다."
  },
  "count_40eced3b": {
    "message": "수"
  },
  "count_plural_0_0_words_one_1_word_other_words_acf32eca": {
    "message": "{ count, plural,\n     =0 {0개 단어}\n    one {1개 단어}\n  other {#개 단어}\n}"
  },
  "count_plural_one_item_loaded_other_items_loaded_857023b7": {
    "message": "{ count, plural,\n    one {#개 항목 로드됨}\n  other {#개 항목 로드됨}\n}"
  },
  "course_documents_104d76e0": {
    "message": "과목 문서"
  },
  "course_files_62deb8f8": {
    "message": "과목 파일"
  },
  "course_files_a31f97fc": {
    "message": "과목 파일"
  },
  "course_images_f8511d04": {
    "message": "과목 이미지"
  },
  "course_link_b369426": {
    "message": "과목 링크"
  },
  "course_links_b56959b9": {
    "message": "과목 링크"
  },
  "course_media_ec759ad": {
    "message": "과목 미디어"
  },
  "course_navigation_dd035109": {
    "message": "과목 탐색"
  },
  "create_icon_110d6463": {
    "message": "아이콘 만들기"
  },
  "create_icon_maker_icon_c716bffe": {
    "message": "아이콘 메이커 아이콘 만들기"
  },
  "creative_commons_license_725584ae": {
    "message": "Creative Commons 라이선스:"
  },
  "crop_image_41bf940c": {
    "message": "이미지 자르기"
  },
  "crop_image_807ebb08": {
    "message": "이미지 자르기"
  },
  "cup_product_14174434": {
    "message": "합집합"
  },
  "current_image_f16c249c": {
    "message": "현재 이미지"
  },
  "current_link_945a47ee": {
    "message": "현재 링크"
  },
  "current_volume_level_c55ab825": {
    "message": "현재 볼륨 수준"
  },
  "custom_6979cd81": {
    "message": "사용자 지정"
  },
  "cyan_c1d5f68a": {
    "message": "녹청"
  },
  "dagger_57e0f4e5": {
    "message": "단검"
  },
  "date_added_ed5ad465": {
    "message": "추가된 날짜"
  },
  "decorative_icon_9a7f3fc3": {
    "message": "장식 아이콘"
  },
  "decorative_image_fde98579": {
    "message": "장식 이미지"
  },
  "decorative_type_upper_f2c95e3": {
    "message": "장식 { TYPE_UPPER }"
  },
  "decrease_indent_d9cf469d": {
    "message": "들여쓰기 줄이기"
  },
  "decrease_rich_content_area_82068f64": {
    "message": "서식 있는 콘텐츠 영역 줄이기"
  },
  "deep_purple_bb3e2907": {
    "message": "짙은 보라색"
  },
  "default_9db103d": {
    "message": "기본값"
  },
  "default_bulleted_unordered_list_47079da8": {
    "message": "기본값 글머리 기호 순서가 지정되지 않은 목록"
  },
  "default_numerical_ordered_list_48dd3548": {
    "message": "기본값 숫자 순서 목록"
  },
  "definite_integral_fe7ffed1": {
    "message": "정적분"
  },
  "degree_symbol_4a823d5f": {
    "message": "도(각도) 기호"
  },
  "delimiters_4db4840d": {
    "message": "구분자"
  },
  "delta_53765780": {
    "message": "델타"
  },
  "describe_the_icon_f6a18823": {
    "message": "(아이콘 설명)"
  },
  "describe_the_type_ff448da5": {
    "message": "({ TYPE } 설명)"
  },
  "description_436c48d7": {
    "message": "설명"
  },
  "details_98a31b68": {
    "message": "세부 정보"
  },
  "diagonal_dots_7d71b57e": {
    "message": "대각선 점"
  },
  "diamond_b8dfe7ae": {
    "message": "다이아몬드"
  },
  "diamonds_suit_526abaaf": {
    "message": "다이아몬드(슈트)"
  },
  "digamma_258ade94": {
    "message": "디감마"
  },
  "dimension_type_f5fa9170": {
    "message": "차원 유형"
  },
  "directionality_26ae9e08": {
    "message": "방향형"
  },
  "directly_edit_latex_b7e9235b": {
    "message": "LaTeX 직접 편집"
  },
  "disable_preview_222bdf72": {
    "message": "미리 보기 사용 중지"
  },
  "discussion_6719c51d": {
    "message": "토론"
  },
  "discussions_a5f96392": {
    "message": "토론"
  },
  "discussions_index_6c36ced": {
    "message": "토론 색인"
  },
  "disjoint_union_e74351a8": {
    "message": "분리합집합"
  },
  "display_options_315aba85": {
    "message": "표시 옵션"
  },
  "display_text_link_opens_in_a_new_tab_75e9afc9": {
    "message": "텍스트 링크 표시(새 탭에서 열기)"
  },
  "div_applied_49ad83fc": {
    "message": "Div 적용됨"
  },
  "div_removed_d13f8e17": {
    "message": "Div 제거됨"
  },
  "division_sign_72190870": {
    "message": "분리 기호"
  },
  "document_678cd7bf": {
    "message": "문서"
  },
  "documents_81393201": {
    "message": "문서"
  },
  "done_54e3d4b6": {
    "message": "완료"
  },
  "double_dagger_faf78681": {
    "message": "이중 단검"
  },
  "down_5831a426": {
    "message": "아래로"
  },
  "down_and_left_diagonal_arrow_40ef602c": {
    "message": "아래 및 왼쪽 대각선 화살표"
  },
  "down_and_right_diagonal_arrow_6ea0f460": {
    "message": "아래 및 오른쪽 대각선 화살표"
  },
  "download_filename_2baae924": {
    "message": "{ filename } 다운로드"
  },
  "downward_arrow_cca52012": {
    "message": "아래쪽 화살표"
  },
  "downward_pointing_triangle_2a12a601": {
    "message": "아래쪽 방향 삼각형"
  },
  "drag_a_file_here_1bf656d5": {
    "message": "여기에 파일 끌기"
  },
  "drag_and_drop_or_click_to_browse_your_computer_60772d6d": {
    "message": "끌어서 놓기 또는 클릭하여 컴퓨터를 찾아보기"
  },
  "drag_handle_use_up_and_down_arrows_to_resize_e29eae5c": {
    "message": "끌기 핸들. 위로 및 아래로 화살표를 사용하여 크기를 조정"
  },
  "due_multiple_dates_cc0ee3f5": {
    "message": "기한: 여러 날짜"
  },
  "due_when_7eed10c6": {
    "message": "기한: { when }"
  },
  "edit_alt_text_for_this_icon_instance_9c6fc5fd": {
    "message": "이 아이콘 인스턴스의 대체 텍스트를 편집"
  },
  "edit_c5fbea07": {
    "message": "편집"
  },
  "edit_course_link_5a5c3c59": {
    "message": "과목 링크 편집"
  },
  "edit_equation_f5279959": {
    "message": "방정식 편집"
  },
  "edit_existing_icon_maker_icon_5d0ebb3f": {
    "message": "기존 아이콘 메이커 아이콘"
  },
  "edit_icon_2c6b0e91": {
    "message": "아이콘 편집"
  },
  "edit_link_7f53bebb": {
    "message": "링크 편집"
  },
  "editor_status_bar_653f44ee": {
    "message": "편집기 상태 표시줄"
  },
  "element_starting_with_start_91bf4c3b": {
    "message": "{ start }(으)로 시작되는 요소"
  },
  "embed_828fac4a": {
    "message": "포함"
  },
  "embed_code_314f1bd5": {
    "message": "코드 포함"
  },
  "embed_content_from_external_tool_3397ad2d": {
    "message": "외부 도구에서 콘텐츠 포함"
  },
  "embed_image_1080badc": {
    "message": "이미지 포함"
  },
  "embed_video_a97a64af": {
    "message": "동영상 포함"
  },
  "embedded_content_aaeb4d3d": {
    "message": "포함된 콘텐츠"
  },
  "empty_set_91a92df4": {
    "message": "공집합"
  },
  "encircled_dot_8f5e51c": {
    "message": "원으로 둘러쌓인 점"
  },
  "encircled_minus_72745096": {
    "message": "원으로 둘러쌓인 빼기"
  },
  "encircled_plus_36d8d104": {
    "message": "원으로 둘러쌓인 더하기"
  },
  "encircled_times_5700096d": {
    "message": "원으로 둘러쌓이 곱하기"
  },
  "engineering_icon_f8f3cf43": {
    "message": "엔지니어링 아이콘"
  },
  "english_icon_25bfe845": {
    "message": "영어 아이콘"
  },
  "enter_a_media_title_81b490ec": {
    "message": "미디어 제목 입력"
  },
  "enter_at_least_3_characters_to_search_4f037ee0": {
    "message": "최소 3자를 입력하여 검색"
  },
  "enter_replacement_text_17631bbc": {
    "message": "교체 텍스트 입력"
  },
  "enter_search_text_26cb4459": {
    "message": "검색 텍스트 입력"
  },
  "epsilon_54bb8afa": {
    "message": "엡실론"
  },
  "epsilon_variant_d31f1e77": {
    "message": "엡실론(변형)"
  },
  "equals_sign_c51bdc58": {
    "message": "등호"
  },
  "equation_1c5ac93c": {
    "message": "방정식"
  },
  "equation_editor_39fbc3f1": {
    "message": "방정식 편집기"
  },
  "equilibrium_6ff3040b": {
    "message": "평형"
  },
  "equivalence_class_7b0f11c0": {
    "message": "동치류"
  },
  "equivalent_identity_654b3ce5": {
    "message": "동등(ID)"
  },
  "eta_b8828f99": {
    "message": "Eta"
  },
  "exists_2e62bdaa": {
    "message": "있음"
  },
  "exit_fullscreen_b7eb0aa4": {
    "message": "전체 화면 나가기"
  },
  "expand_preview_by_default_2abbf9f8": {
    "message": "기본값으로 미리 보기 펼치기"
  },
  "expand_to_see_types_f5d29352": {
    "message": "펼쳐서 { types } 보기"
  },
  "external_link_d3f9e62a": {
    "message": "외부 링크"
  },
  "external_tool_frame_70b32473": {
    "message": "외부 도구 프레임"
  },
  "external_tools_6e77821": {
    "message": "외부 도구"
  },
  "extra_large_b6cdf1ff": {
    "message": "더 크게"
  },
  "extra_large_width_x_height_px_915571fa": {
    "message": "더 크게({ width } x { height }px)"
  },
  "extra_small_9ae33252": {
    "message": "더 작게"
  },
  "extracurricular_icon_67c8ca42": {
    "message": "정식 과목 이외 아이콘"
  },
  "f_function_fe422d65": {
    "message": "F (함수)"
  },
  "fail_544e5dde": {
    "message": "실패"
  },
  "failed_getting_file_contents_e9ea19f4": {
    "message": "파일 콘텐츠를 받지 못함"
  },
  "failed_to_retrieve_content_from_external_tool_5899c213": {
    "message": "외부 도구에서 콘텐츠를 가져오지 못함"
  },
  "file_name_8fd421ff": {
    "message": "파일 이름"
  },
  "file_preview_21667a6e": {
    "message": "파일 미리 보기"
  },
  "file_preview_for_filename_ab314195": {
    "message": "{ fileName }의 파일 미리 보기"
  },
  "file_storage_quota_exceeded_b7846cd1": {
    "message": "파일 스토리지 할당량 초과"
  },
  "file_url_c12b64be": {
    "message": "파일 URL"
  },
  "filename_file_icon_602eb5de": {
    "message": "{ filename } 파일 아이콘"
  },
  "filename_image_preview_6cef8f26": {
    "message": "{ filename } 이미지 미리 보기"
  },
  "filename_text_preview_e41ca2d8": {
    "message": "{ filename } 텍스트 미리 보기"
  },
  "files_c300e900": {
    "message": "파일"
  },
  "files_index_af7c662b": {
    "message": "파일 색인"
  },
  "find_8d605019": {
    "message": "찾기"
  },
  "find_and_replace_6e345933": {
    "message": "찾기 및 바꾸기"
  },
  "finish_bc343002": {
    "message": "완료"
  },
  "fix_heading_hierarchy_f60884c4": {
    "message": "머리글 계층 구조 수정"
  },
  "flat_music_76d5a5c3": {
    "message": "반음 내림(음악)"
  },
  "focus_element_options_toolbar_18d993e": {
    "message": "요소 옵션 도구 모음에 포커스"
  },
  "folder_tree_fbab0726": {
    "message": "폴더 트리"
  },
  "for_all_b919f972": {
    "message": "전체"
  },
  "format_4247a9c5": {
    "message": "형식"
  },
  "format_as_a_list_142210c3": {
    "message": "목록 형식"
  },
  "formatting_5b143aa8": {
    "message": "형식 지정"
  },
  "forward_slash_3f90f35e": {
    "message": "슬래시"
  },
  "found_auto_saved_content_3f6e4ca5": {
    "message": "자동 저장된 콘텐츠를 찾음"
  },
  "found_count_plural_0_results_one_result_other_resu_46aeaa01": {
    "message": "{ count, plural,\n     =0 {#개 결과 찾음}\n    one {#개 결과 찾음}\n  other {#개 결과 찾음}\n}"
  },
  "fraction_41bac7af": {
    "message": "분수"
  },
  "fullscreen_873bf53f": {
    "message": "전체 화면"
  },
  "gamma_1767928": {
    "message": "감마"
  },
  "generating_preview_45b53be0": {
    "message": "미리 보기 생성 중..."
  },
  "gif_png_format_images_larger_than_size_kb_are_not__7af3bdbd": {
    "message": "{ size }KB를 초과하는 GIF/PNG 형식 이미지는 현재 지원하지 않습니다."
  },
  "go_to_the_editor_s_menubar_e6674c81": {
    "message": "편집기의 메뉴 모음으로 이동"
  },
  "go_to_the_editor_s_toolbar_a5cb875f": {
    "message": "편집기의 도구 모음으로 이동"
  },
  "grades_a61eba0a": {
    "message": "성적"
  },
  "graphics_text_bc9568bc": {
    "message": "그래픽 텍스트"
  },
  "greater_than_e98af662": {
    "message": "초과"
  },
  "greater_than_or_equal_b911949a": {
    "message": "이상"
  },
  "greek_65c5b3f7": {
    "message": "그리스어"
  },
  "green_15af4778": {
    "message": "녹색"
  },
  "grey_a55dceff": {
    "message": "회색"
  },
  "group_documents_8bfd6ae6": {
    "message": "그룹 문서"
  },
  "group_files_4324f3df": {
    "message": "그룹 파일"
  },
  "group_files_82e5dcdb": {
    "message": "그룹 파일"
  },
  "group_images_98e0ac17": {
    "message": "그룹 이미지"
  },
  "group_isomorphism_45b1458c": {
    "message": "그룹 동형사상"
  },
  "group_link_63e626b3": {
    "message": "그룹 링크"
  },
  "group_links_9493129e": {
    "message": "그룹 링크"
  },
  "group_media_2f3d128a": {
    "message": "그룹 미디어"
  },
  "group_navigation_99f191a": {
    "message": "그룹 탐색"
  },
  "h_bar_bb94deae": {
    "message": "H 막대"
  },
  "hat_ea321e35": {
    "message": "모자"
  },
  "header_column_f27433cb": {
    "message": "헤더 열"
  },
  "header_row_and_column_ec5b9ec": {
    "message": "헤더 행 및 열"
  },
  "header_row_f33eb169": {
    "message": "헤더 행"
  },
  "heading_2_5b84eed2": {
    "message": "머리글 2"
  },
  "heading_3_2c83de44": {
    "message": "머리글 3"
  },
  "heading_4_b2e74be7": {
    "message": "머리글 4"
  },
  "heading_h_applied_eccd294d": {
    "message": "머리글 { h } 적용됨"
  },
  "heading_h_removed_745f24a6": {
    "message": "머리글 { h } 제거됨"
  },
  "heading_levels_should_not_be_skipped_3947c0e0": {
    "message": "머리글 수준을 건너뛸 수 없습니다."
  },
  "heading_starting_with_start_42a3e7f9": {
    "message": "{ start }(으)로 시작되는 머리글"
  },
  "headings_should_not_contain_more_than_120_characte_3c0e0cb3": {
    "message": "머리글은 120자 이상을 포함할 수 없습니다."
  },
  "health_icon_8d292eb5": {
    "message": "건강 아이콘"
  },
  "hearts_suit_e50e04ca": {
    "message": "하트(슈트)"
  },
  "height_69b03e15": {
    "message": "높이"
  },
  "hexagon_d8468e0d": {
    "message": "6각형"
  },
  "hide_description_bfb5502e": {
    "message": "설명 숨기기"
  },
  "hide_title_description_caf092ef": {
    "message": "{ title } 설명 숨기기"
  },
  "highlight_an_element_to_activate_the_element_optio_60e1e56b": {
    "message": "요소를 강조 표시하여 요소 옵션 도구 모음을 활성화"
  },
  "home_351838cd": {
    "message": "홈"
  },
  "how_to_request_and_edit_captions_a49a9c6b": {
    "message": "어떻게 캡션을 요청 및 편집합니까?"
  },
  "html_code_editor_fd967a44": {
    "message": "html 코드 편집기"
  },
  "html_editor_fb2ab713": {
    "message": "HTML 편집기"
  },
  "i_have_obtained_permission_to_use_this_file_6386f087": {
    "message": "이 파일을 사용할 권한을 획득했습니다."
  },
  "i_hold_the_copyright_71ee91b1": {
    "message": "저작권을 보유합니다"
  },
  "icon_215a1dc6": {
    "message": "아이콘"
  },
  "icon_8168b2f8": {
    "message": "아이콘"
  },
  "icon_color_b86dd6d6": {
    "message": "아이콘 색"
  },
  "icon_maker_icons_cc560f7e": {
    "message": "아이콘 메이커 아이콘"
  },
  "icon_options_7e32746e": {
    "message": "아이콘 옵션"
  },
  "icon_options_tray_2b407977": {
    "message": "아이콘 옵션 트레이"
  },
  "icon_preview_1782a1d9": {
    "message": "아이콘 미리 보기"
  },
  "icon_shape_30b61e7": {
    "message": "아이콘 모양"
  },
  "icon_size_9353edea": {
    "message": "아이콘 크기"
  },
  "if_left_empty_link_text_will_display_as_course_lin_2a34eedb": {
    "message": "비워둔 경우, 링크 텍스트는 과목 링크 이름으로 표시됩니다"
  },
  "if_usage_rights_are_required_the_file_will_not_pub_841e276e": {
    "message": "사용 권리가 필요한 경우, 파일 페이지에서 사용으로 설정할 때까지 파일은 게시되지 않습니다."
  },
  "if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5": {
    "message": "지금은 사용을 선택하지 않은 경우, 이 파일은 업로드된 후에 게시 취소됩니다."
  },
  "image_8ad06": {
    "message": "이미지"
  },
  "image_c1c98202": {
    "message": "이미지"
  },
  "image_filenames_should_not_be_used_as_the_alt_attr_bcfd7780": {
    "message": "이미지 파일 이름은 이미지 콘텐츠를 설명하는 대체 특성으로 사용하지 않아야 합니다."
  },
  "image_options_5412d02c": {
    "message": "이미지 옵션"
  },
  "image_options_tray_90a46006": {
    "message": "이미지 옵션 트레이"
  },
  "image_to_crop_3a34487d": {
    "message": "자를 이미지"
  },
  "image_with_filename_file_aacd7180": {
    "message": "파일 이름이 { file }인 이미지"
  },
  "images_7ce26570": {
    "message": "이미지"
  },
  "images_should_include_an_alt_attribute_describing__b86d6a86": {
    "message": "이미지는 이미지 콘텐츠를 설명하는 대체 특성을 포함해야 합니다."
  },
  "imaginary_portion_of_complex_number_2c733ffa": {
    "message": "허수 부분(복소수 중에서)"
  },
  "in_element_of_19ca2f33": {
    "message": "안에(요소 중에서)"
  },
  "increase_indent_6af90f7c": {
    "message": "들여쓰기 늘리기"
  },
  "increase_rich_content_area_340b775": {
    "message": "서식 있는 콘텐츠 영역 늘리기"
  },
  "indefinite_integral_6623307e": {
    "message": "부정적분"
  },
  "index_of_max_80dcf7a5": {
    "message": "{ index }/{ max }"
  },
  "indigo_2035fc55": {
    "message": "인디고"
  },
  "inference_fed5c960": {
    "message": "추론"
  },
  "infinity_7a10f206": {
    "message": "무한"
  },
  "input_field_for_alpha_678265fd": {
    "message": "알파에 대한 입력 필드"
  },
  "input_field_for_blue_561e020a": {
    "message": "파랑에 대한 입력 필드"
  },
  "input_field_for_green_67f8b2b6": {
    "message": "녹색에 대한 입력 필드"
  },
  "input_field_for_red_86a84615": {
    "message": "빨강에 대한 입력 필드"
  },
  "insert_593145ef": {
    "message": "삽입"
  },
  "insert_link_6dc23cae": {
    "message": "링크 삽입"
  },
  "insert_math_equation_57c6e767": {
    "message": "수학 방정식 삽입"
  },
  "integers_336344e1": {
    "message": "정수"
  },
  "intersection_cd4590e4": {
    "message": "교집합"
  },
  "invalid_description_991e23bb": {
    "message": "잘못된 설명"
  },
  "invalid_entry_f7d2a0f5": {
    "message": "잘못된 입력입니다."
  },
  "invalid_file_c11ba11": {
    "message": "잘못된 파일"
  },
  "invalid_file_type_881cc9b2": {
    "message": "잘못된 파일 유형"
  },
  "invalid_url_cbde79f": {
    "message": "잘못된 URL"
  },
  "iota_11c932a9": {
    "message": "이오타"
  },
  "issue_num_total_f94536cf": {
    "message": "문제 { num }/{ total }:"
  },
  "italic_applied_8f59a684": {
    "message": "기울임꼴 적용됨"
  },
  "italic_removed_17cbab6f": {
    "message": "기울임꼴 제거됨"
  },
  "kappa_2f14c816": {
    "message": "카파"
  },
  "kappa_variant_eb64574b": {
    "message": "카파(변형)"
  },
  "keyboard_shortcuts_ed1844bd": {
    "message": "키보드 바로 가기 키"
  },
  "keyboards_navigate_to_links_using_the_tab_key_two__5fab8c82": {
    "message": "Tab 키를 사용하여 링크로 키보드 탐색합니다. 같은 대상으로 이동하는 두 개의 인접한 링크는 키보드 사용자에게 혼동될 수 있습니다."
  },
  "lambda_4f602498": {
    "message": "람다"
  },
  "language_arts_icon_a798b0f8": {
    "message": "어학 아이콘"
  },
  "languages_icon_9d20539": {
    "message": "언어 아이콘"
  },
  "large_9c5e80e7": {
    "message": "큰"
  },
  "large_text_e7ba08cd": {
    "message": "큰 텍스트"
  },
  "large_width_x_height_px_c61c2fd": {
    "message": "크게({ width } x { height }px)"
  },
  "learn_ad3b3505": {
    "message": "학습"
  },
  "learn_more_about_adjacent_links_2cb9762c": {
    "message": "인접한 링크에 대해 자세히 알아보기"
  },
  "learn_more_about_color_contrast_c019dfb9": {
    "message": "색 대비에 대해 자세히 알아보기"
  },
  "learn_more_about_organizing_page_headings_8a7caa2e": {
    "message": "페이지 머리글 구성에 대해 자세히 알아보기"
  },
  "learn_more_about_proper_page_heading_structure_d2959f2d": {
    "message": "적절한 페이지 머리글 구성에 대해 자세히 알아보기"
  },
  "learn_more_about_table_headers_5f5ee13": {
    "message": "표 헤더에 대해 자세히 알아보기"
  },
  "learn_more_about_using_alt_text_for_images_5698df9a": {
    "message": "이미지의 대체 택스트 사용에 대해 자세히 알아보기"
  },
  "learn_more_about_using_captions_with_tables_36fe496f": {
    "message": "표에서 캡션 사용에 대해 자세히 알아보기"
  },
  "learn_more_about_using_filenames_as_alt_text_264286af": {
    "message": "파일 이름을 대체 텍스트로 사용하기에 대해 자세히 알아보기"
  },
  "learn_more_about_using_lists_4e6eb860": {
    "message": "목록 사용에 대해 자세히 알아보기"
  },
  "learn_more_about_using_scope_attributes_with_table_20df49aa": {
    "message": "표에서 범위 사용에 대해 자세히 알아보기"
  },
  "leave_as_is_4facfe55": {
    "message": "그대로 두기"
  },
  "left_3ea9d375": {
    "message": "왼쪽"
  },
  "left_align_43d95491": {
    "message": "왼쪽 정렬"
  },
  "left_angle_bracket_c87a6d07": {
    "message": "왼쪽 꺾쇠 괄호"
  },
  "left_arrow_4fde1a64": {
    "message": "왼쪽 화살표"
  },
  "left_arrow_with_hook_5bfcad93": {
    "message": "후크가 있는 왼쪽 화살표"
  },
  "left_ceiling_ee9dd88a": {
    "message": "왼쪽 천장 함수"
  },
  "left_curly_brace_1726fb4": {
    "message": "왼쪽 중괄호"
  },
  "left_downard_harpoon_arrow_1d7b3d2e": {
    "message": "왼쪽 아래로 향한 작살 화살표"
  },
  "left_floor_29ac2274": {
    "message": "왼쪽 바닥 함수"
  },
  "left_to_right_e9b4fd06": {
    "message": "왼쪽에서 오른쪽"
  },
  "left_upward_harpoon_arrow_3a562a96": {
    "message": "왼쪽 위로 향한 작살 화살표"
  },
  "leftward_arrow_1e4765de": {
    "message": "왼쪽으로 향한 화살표"
  },
  "leftward_pointing_triangle_d14532ce": {
    "message": "왼쪽 방향 삼각형"
  },
  "less_than_a26c0641": {
    "message": "미만"
  },
  "less_than_or_equal_be5216cb": {
    "message": "이하"
  },
  "library_icon_ae1e54cf": {
    "message": "라이브러리 아이콘"
  },
  "light_blue_5374f600": {
    "message": "옅은 파랑"
  },
  "link_7262adec": {
    "message": "링크"
  },
  "link_options_a16b758b": {
    "message": "링크 옵션"
  },
  "link_type_linktypemessage_c6d26815": {
    "message": "링크 유형: { linkTypeMessage }"
  },
  "link_with_text_starting_with_start_b3fcbe71": {
    "message": "{ start }(으)로 시작되는 텍스트의 링크"
  },
  "links_14b70841": {
    "message": "링크"
  },
  "links_to_an_external_site_de74145d": {
    "message": "외부 사이트로 링크입니다."
  },
  "lists_cd1336fc": {
    "message": "목록"
  },
  "lists_should_be_formatted_as_lists_f862de8d": {
    "message": "목록은 목록 형식입니다."
  },
  "load_more_35d33c7": {
    "message": "더 로드"
  },
  "loading_25990131": {
    "message": "로드 중..."
  },
  "loading_bde52856": {
    "message": "로드"
  },
  "loading_closed_captions_subtitles_failed_95ceef47": {
    "message": "캡션/자막을 로드하지 못했습니다."
  },
  "loading_external_tool_d839042c": {
    "message": "외부 도구 로드"
  },
  "loading_failed_b3524381": {
    "message": "로드하지 못했습니다..."
  },
  "loading_failed_e6a9d8ef": {
    "message": "로드하지 못했습니다."
  },
  "loading_folders_d8b5869e": {
    "message": "폴더 로드"
  },
  "loading_placeholder_for_filename_792ef5e8": {
    "message": "{ fileName }의 자료 표시자 로드"
  },
  "loading_please_wait_d276220a": {
    "message": "로드 중입니다. 기다려 주세요"
  },
  "loading_preview_9f077aa1": {
    "message": "미리 보기 로드"
  },
  "lock_speed_at_1x_57d4f815": {
    "message": "속도를 1x로 잠금"
  },
  "locked_762f138b": {
    "message": "잠김"
  },
  "logical_equivalence_76fca396": {
    "message": "논리적 동등"
  },
  "logical_equivalence_short_8efd7b4f": {
    "message": "논리적 동등(짧음)"
  },
  "logical_equivalence_short_and_thick_1e1f654d": {
    "message": "논리적 동등(짧고 굵게)"
  },
  "logical_equivalence_thick_662dd3f2": {
    "message": "논리적 동등(굵게)"
  },
  "low_horizontal_dots_cc08498e": {
    "message": "낮은 수평 점"
  },
  "magenta_4a65993c": {
    "message": "자홍색"
  },
  "maps_to_e5ef7382": {
    "message": "매핑 대상"
  },
  "math_icon_ad4e9d03": {
    "message": "수학 아이콘"
  },
  "media_af190855": {
    "message": "미디어"
  },
  "media_file_is_processing_please_try_again_later_58a6d49": {
    "message": "미디어 파일을 처리 중입니다. 나중에 다시 시도하세요."
  },
  "media_options_saved_560c4ec8": {
    "message": "미디어 옵션을 저장했습니다."
  },
  "media_title_2112243b": {
    "message": "미디어 제목"
  },
  "medium_5a8e9ead": {
    "message": "중간"
  },
  "medium_width_x_height_px_b076f6b6": {
    "message": "중간({ width } x { height }px)"
  },
  "merge_links_2478df96": {
    "message": "링크 병합"
  },
  "mic_a7f3d311": {
    "message": "마이크"
  },
  "microphone_disabled_15c83130": {
    "message": "마이크 사용 안 함"
  },
  "middle_27dc1d5": {
    "message": "중간"
  },
  "minimize_file_preview_da911944": {
    "message": "파일 미리 보기 최소화"
  },
  "minimize_video_20aa554b": {
    "message": "동영상 최소화"
  },
  "minus_fd961e2e": {
    "message": "빼기"
  },
  "minus_plus_3461f637": {
    "message": "빼기/더하기"
  },
  "misc_3b692ea7": {
    "message": "기타"
  },
  "miscellaneous_e9818229": {
    "message": "기타"
  },
  "module_90d9fd32": {
    "message": "모듈"
  },
  "modules_c4325335": {
    "message": "모듈"
  },
  "moving_image_to_crop_directionword_6f66cde2": {
    "message": "이미지를 이동하여 { directionWord } 자르기"
  },
  "mu_37223b8b": {
    "message": "뮤"
  },
  "multi_color_image_63d7372f": {
    "message": "여러 색 이미지"
  },
  "multiplication_sign_15f95c22": {
    "message": "곱하기 기호"
  },
  "music_icon_4db5c972": {
    "message": "음악 아이콘"
  },
  "my_files_2f621040": {
    "message": "내 파일"
  },
  "n_th_root_9991a6e4": {
    "message": "n제곱근"
  },
  "nabla_1e216d25": {
    "message": "나블라"
  },
  "name_1aed4a1b": {
    "message": "이름"
  },
  "name_color_ceec76ff": {
    "message": "{ name }({ color })"
  },
  "natural_music_54a70258": {
    "message": "제자리(음악)"
  },
  "natural_numbers_3da07060": {
    "message": "자연수"
  },
  "navigate_through_the_menu_or_toolbar_415a4e50": {
    "message": "메뉴 또는 도구 모음 탐색"
  },
  "navigation_ee9af92d": {
    "message": "탐색"
  },
  "nested_greater_than_d852e60d": {
    "message": "중첩된 초과"
  },
  "nested_less_than_27d17e58": {
    "message": "중첩된 미만"
  },
  "new_quiz_34aacba6": {
    "message": "새로운 퀴즈"
  },
  "next_40e12421": {
    "message": "다음"
  },
  "next_findtext_9d69f0fe": {
    "message": "다음 { findText }"
  },
  "no_accessibility_issues_were_detected_f8d3c875": {
    "message": "탐지된 접근성 문제가 없습니다."
  },
  "no_announcements_created_yet_c44a94f4": {
    "message": "아직 공지를 만들지 않았습니다."
  },
  "no_announcements_found_20185afc": {
    "message": "찾은 공지가 없습니다."
  },
  "no_assignments_created_yet_1b236d87": {
    "message": "아직 과제를 만들지 않았습니다."
  },
  "no_assignments_found_79e46d7f": {
    "message": "찾은 과제가 없습니다."
  },
  "no_changes_to_save_d29f6e91": {
    "message": "저장할 변경 사항이 없습니다."
  },
  "no_discussions_created_yet_ff99abe3": {
    "message": "아직 토론을 만들지 않았습니다."
  },
  "no_discussions_found_9284063b": {
    "message": "찾은 토론이 없습니다."
  },
  "no_e16d9132": {
    "message": "아니요"
  },
  "no_file_chosen_9a880793": {
    "message": "선택됨 파일 없음"
  },
  "no_headers_9bc7dc7f": {
    "message": "헤더 없음"
  },
  "no_modules_created_yet_c71b6d4d": {
    "message": "아직 모듈을 만들지 않았습니다."
  },
  "no_modules_found_2df43a40": {
    "message": "찾은 모듈이 없습니다."
  },
  "no_pages_created_yet_c379fa6e": {
    "message": "아직 페이지를 만들지 않았습니다."
  },
  "no_pages_found_6799350": {
    "message": "찾은 페이지가 없습니다."
  },
  "no_preview_is_available_for_this_file_f940114a": {
    "message": "이 파일에 대한 미리 보기가 없습니다."
  },
  "no_quizzes_created_yet_1a2370b9": {
    "message": "아직 퀴즈를 만들지 않았습니다."
  },
  "no_quizzes_found_c80c537a": {
    "message": "찾은 퀴즈가 없습니다."
  },
  "no_results_940393cf": {
    "message": "결과가 없습니다."
  },
  "no_results_found_58717065": {
    "message": "찾은 결과가 없습니다"
  },
  "no_results_found_for_filterterm_ad1b04c8": {
    "message": "{ filterTerm }에 대한 결과를 찾을 수 없음"
  },
  "no_video_1ed00b26": {
    "message": "동영상 없음"
  },
  "none_3b5e34d2": {
    "message": "없음"
  },
  "none_selected_b93d56d2": {
    "message": "선택하지 않음"
  },
  "normal_text_7b03da48": {
    "message": "일반 텍스트"
  },
  "not_equal_6e2980e6": {
    "message": "같지 않음"
  },
  "not_in_not_an_element_of_fb1ffb54": {
    "message": "포함되지 않음(요소 아님)"
  },
  "not_negation_1418ebb8": {
    "message": "아니요(부정)"
  },
  "not_subset_dc2b5e84": {
    "message": "부분집합 아님"
  },
  "not_subset_strict_23d282bf": {
    "message": "부분집합 아님(진부분집합)"
  },
  "not_superset_5556b913": {
    "message": "초집합 아님"
  },
  "not_superset_strict_24e06f36": {
    "message": "초집합 아님(진초집합)"
  },
  "nu_1c0f6848": {
    "message": "누우"
  },
  "octagon_e48be9f": {
    "message": "8각형"
  },
  "olive_6a3e4d6b": {
    "message": "올리브"
  },
  "omega_8f2c3463": {
    "message": "오메가"
  },
  "one_of_the_following_styles_must_be_added_to_save__1de769aa": {
    "message": "아이콘을 저장하려면 다음 중 한 스타일을 추가해야 합니다: 아이콘 색, 윤곽 크기, 아이콘 텍스트 또는 이미지"
  },
  "one_or_more_files_failed_to_paste_please_try_uploa_7fa39dd3": {
    "message": "한 개 이상의 파일을 붙여넣지 못했습니다. 파일을 업로드 또는 끌어서 놓기를 시도하세요."
  },
  "open_circle_e9bd069": {
    "message": "열린 원"
  },
  "open_this_keyboard_shortcuts_dialog_9658b83a": {
    "message": "이 키보드 바로 가기 키 대화 상자 열기"
  },
  "open_title_application_fd624fc5": {
    "message": "{ title } 애플리케이션 열기"
  },
  "operators_a2ef9a93": {
    "message": "연산자"
  },
  "options_3ab0ea65": {
    "message": "옵션"
  },
  "or_9b70ccaa": {
    "message": "또는"
  },
  "orange_81386a62": {
    "message": "오렌지색"
  },
  "ordered_and_unordered_lists_cfadfc38": {
    "message": "순서가 지정된 및 지정되지 않은 목록"
  },
  "other_editor_shortcuts_may_be_found_at_404aba4a": {
    "message": "다음에서 기타 편집기 바로 가기를 찾을 수 있습니다"
  },
  "outline_color_3ef2cea7": {
    "message": "윤곽 색"
  },
  "outline_size_a6059a21": {
    "message": "윤곽 크기"
  },
  "p_is_not_a_valid_protocol_b1c4efaa": {
    "message": "{ p }은(는) 유효한 프로토콜이 아닙니다."
  },
  "page_50c4823d": {
    "message": "페이지"
  },
  "pages_e5414c2c": {
    "message": "페이지"
  },
  "paragraph_5e5ad8eb": {
    "message": "문단"
  },
  "paragraph_applied_959b3fe5": {
    "message": "문단 적용됨"
  },
  "paragraph_removed_d09320e": {
    "message": "문단 제거됨"
  },
  "paragraph_starting_with_start_a59923f8": {
    "message": "{ start }(으)로 시작하는 문단"
  },
  "parallel_d55d6e38": {
    "message": "수평"
  },
  "partial_derivative_4a9159df": {
    "message": "부분적(파생)"
  },
  "pass_1c19a2b3": {
    "message": "통과"
  },
  "paste_5963d1c1": {
    "message": "붙여넣기"
  },
  "pause_12af3bb4": {
    "message": "일시 중지"
  },
  "pentagon_17d82ea3": {
    "message": "5각형"
  },
  "people_b4ebb13c": {
    "message": "사용자"
  },
  "percentage_34ab7c2c": {
    "message": "백분율"
  },
  "percentage_must_be_a_number_8033c341": {
    "message": "백분율은 숫자여야 합니다"
  },
  "percentage_must_be_at_least_percentage_a98ca8fc": {
    "message": "백분율은 최소 { percentage }%이어야 합니다"
  },
  "performing_arts_icon_f3497486": {
    "message": "공연 예술 아이콘"
  },
  "perpendicular_7c48ede4": {
    "message": "직각"
  },
  "phi_4ac33b6d": {
    "message": "파이(Phi)"
  },
  "phi_variant_c9bb3ac5": {
    "message": "파이(Phi, 변형)"
  },
  "physical_education_icon_d7dffd3e": {
    "message": "체육 아이콘"
  },
  "pi_dc4f0bd8": {
    "message": "파이(Pi)"
  },
  "pi_variant_10f5f520": {
    "message": "파이(Pi, 변형)"
  },
  "pick_a_color_557abfb0": {
    "message": "색 선택"
  },
  "pink_68ad45cb": {
    "message": "핑크색"
  },
  "pixels_52ece7d1": {
    "message": "픽셀"
  },
  "pixels_must_be_at_least_width_x_height_px_e965edd5": {
    "message": "픽셀은 최소 { width } x { height }px여야 합니다"
  },
  "play_1a47eaa7": {
    "message": "재생"
  },
  "play_media_comment_35257210": {
    "message": "미디어 댓글을  재생합니다."
  },
  "play_media_comment_by_name_from_createdat_c230123d": {
    "message": "{ createdAt }에서 { name } 님의 미디어 댓글을 재생합니다."
  },
  "player_layout_14e09a29": {
    "message": "플레이어 레이아웃"
  },
  "please_allow_canvas_to_access_your_microphone_and__dc2c3079": {
    "message": "Canvas에서 마이크 및 웹캠에 액세스를 허용하세요."
  },
  "please_choose_a_file_c2449cc": {
    "message": "파일을 선택하세요"
  },
  "please_enter_a_file_name_f159edc1": {
    "message": "파일 이름을 입력하세요"
  },
  "please_enter_a_valid_video_url_from_a_supported_pl_30dc0596": {
    "message": "지원되는 플랫폼에서 유효한 동영상 URL을 입력하세요."
  },
  "please_select_a_file_of_a_supported_type_1fc578f2": {
    "message": "지원하는 유형의 파일을 선택하세요"
  },
  "plus_d43cd4ec": {
    "message": "더하기"
  },
  "plus_minus_f8be2e83": {
    "message": "더하기/빼기"
  },
  "posted_when_a578f5ab": {
    "message": "게시됨: { when }"
  },
  "power_set_4f26f316": {
    "message": "멱집합"
  },
  "precedes_196b9aef": {
    "message": "선행"
  },
  "precedes_equal_20701e84": {
    "message": "선행하거나 동등"
  },
  "preformatted_d0670862": {
    "message": "미리 형식이 적용"
  },
  "prepend_findtext_append_8e0e769a": {
    "message": "{ prepend }{ findText }{ append }"
  },
  "prev_f82cbc48": {
    "message": "이전"
  },
  "preview_53003fd2": {
    "message": "미리 보기"
  },
  "preview_a3f8f854": {
    "message": "미리 보기"
  },
  "preview_in_overlay_ed772c46": {
    "message": "오버레이에서 미리 보기"
  },
  "preview_inline_9787330": {
    "message": "인라인 미리 보기"
  },
  "previous_bd2ac015": {
    "message": "이전"
  },
  "previous_findtext_8dfbfd30": {
    "message": "이전 { findText }"
  },
  "previously_chosen_colors_f1338315": {
    "message": "이전에 선택된 색"
  },
  "prime_917ea60e": {
    "message": "기수"
  },
  "prime_numbers_13464f61": {
    "message": "기수"
  },
  "product_39cf144f": {
    "message": "제품/곱"
  },
  "proportional_f02800cc": {
    "message": "비례"
  },
  "protocol_must_be_ftp_http_https_mailto_skype_tel_o_73beb4f8": {
    "message": "프로토콜은 ftp, http, https, mailto, skype 또는 tel이어야 하며 생략할 수 있습니다 "
  },
  "psi_e3f5f0f7": {
    "message": "프사이"
  },
  "published_c944a23d": {
    "message": "게시됨"
  },
  "published_when_302d8e23": {
    "message": "게시됨: { when }"
  },
  "pumpkin_904428d5": {
    "message": "호박"
  },
  "purple_7678a9fc": {
    "message": "보라색"
  },
  "quaternions_877024e0": {
    "message": "사원수"
  },
  "quiz_e0dcce8f": {
    "message": "퀴즈"
  },
  "quizzes_7e598f57": {
    "message": "퀴즈"
  },
  "rational_numbers_80ddaa4a": {
    "message": "유리수"
  },
  "real_numbers_7c99df94": {
    "message": "실수"
  },
  "real_portion_of_complex_number_7dad33b5": {
    "message": "실수 부분(복소수 중에서)"
  },
  "record_7c9448b": {
    "message": "녹음/녹화"
  },
  "record_upload_media_5fdce166": {
    "message": "미디어 녹화/업로드"
  },
  "recording_98da6bda": {
    "message": "녹음/녹화"
  },
  "red_8258edf3": {
    "message": "빨강"
  },
  "relationships_6602af70": {
    "message": "관계"
  },
  "religion_icon_246e0be1": {
    "message": "종교 아이콘"
  },
  "remove_f47dc62a": {
    "message": "제거"
  },
  "remove_filename_3ea029f6": {
    "message": "{ filename } 제거"
  },
  "remove_heading_style_5fdc8855": {
    "message": "머리글 스타일 제거"
  },
  "remove_link_d1f2f4d0": {
    "message": "링크 제거"
  },
  "replace_all_d3d68b3": {
    "message": "모두 바꾸기"
  },
  "replace_all_findtext_with_replacetext_da574b32": {
    "message": "모든 { findText }을(를) { replaceText }(으)로 바꾸기"
  },
  "replace_e61834a7": {
    "message": "바꾸기"
  },
  "replace_findtext_with_replacetext_7b5c7fb3": {
    "message": "{ findText }을(를) { replaceText }(으)로 바꾸기"
  },
  "replace_with_eeff01ad": {
    "message": "다음으로 바꾸기"
  },
  "replaced_alertfindtext_with_alertreplacetext_de5c1795": {
    "message": "{ alertFindText }을(를) { alertReplaceText }(으)로 바꿈"
  },
  "replaced_all_alertfindtext_with_alertreplacetext_83fdfe59": {
    "message": "모든 { alertFindText }을(를) { alertReplaceText }(으)로 바꿈"
  },
  "reset_95a81614": {
    "message": "초기화"
  },
  "resize_ec83d538": {
    "message": "크기 변경"
  },
  "restore_auto_save_deccd84b": {
    "message": "자동 저장을 복권하시겠습니까?"
  },
  "result_index_of_max_7db5ad8b": {
    "message": "결과 { index }/{ max }"
  },
  "reverse_turnstile_does_not_yield_7558be06": {
    "message": "왼쪽 함의(산출하지 않음)"
  },
  "rho_a0244a36": {
    "message": "로"
  },
  "rho_variant_415245cd": {
    "message": "로(변형)"
  },
  "rich_content_editor_2708ef21": {
    "message": "서식 있는 콘텐츠 편집기"
  },
  "rich_text_area_press_oskey_f8_for_rich_content_edi_c2f651d": {
    "message": "서식 있는 텍스트 영역입니다. 서식 있는 콘텐츠 편집기 바로 가기는 { OSKey }+F8키를 누릅니다."
  },
  "right_71ffdc4d": {
    "message": "오른쪽"
  },
  "right_align_39e7a32a": {
    "message": "오른쪽 정렬"
  },
  "right_angle_bracket_d704e2d6": {
    "message": "오른쪽 꺾쇠 괄호"
  },
  "right_arrow_35e0eddf": {
    "message": "오른쪽 화살표"
  },
  "right_arrow_with_hook_29d92d31": {
    "message": "후크가 있는 오른쪽 화살표"
  },
  "right_ceiling_839dc744": {
    "message": "오른쪽 천장 함수"
  },
  "right_curly_brace_5159d5cd": {
    "message": "왼쪽 중괄호"
  },
  "right_downward_harpoon_arrow_d71b114f": {
    "message": "오른쪽 아래로 향한 작살 화살표"
  },
  "right_floor_5392d5cf": {
    "message": "오른쪽 바닥 함수"
  },
  "right_to_left_9cfb092a": {
    "message": "오른쪽에서 왼쪽"
  },
  "right_upward_harpoon_arrow_f5a34c73": {
    "message": "오른쪽 위로 향한 작살 화살표"
  },
  "rightward_arrow_32932107": {
    "message": "오른쪽 방향 화살표"
  },
  "rightward_pointing_triangle_60330f5c": {
    "message": "오른쪽 방향 삼각형"
  },
  "rotate_image_90_degrees_2ab77c05": {
    "message": "이미지를 -90도 회전"
  },
  "rotate_image_90_degrees_6c92cd42": {
    "message": "이미지를 90도 회전"
  },
  "rotation_9699c538": {
    "message": "회전"
  },
  "row_fc0944a7": {
    "message": "행"
  },
  "row_group_979f5528": {
    "message": "행 그룹"
  },
  "sadly_the_pretty_html_editor_is_not_keyboard_acces_50da7665": {
    "message": "아쉽게도 Pretty HTML 편집기는 키보드로 액세스할 수 없습니다. 여기에서 원시 HTML 편집기에 액세스하세요."
  },
  "save_11a80ec3": {
    "message": "저장"
  },
  "save_copy_ca63944e": {
    "message": "복사본 저장"
  },
  "save_media_cb9e786e": {
    "message": "미디어 저장"
  },
  "saved_icon_maker_icons_df86e2a1": {
    "message": "저장된 아이콘 메이커 아이콘"
  },
  "screen_readers_cannot_determine_what_is_displayed__6a5842ab": {
    "message": "화면 읽기 프로그램은 대체 텍스트가 없으면 이미지가 무엇을 표시하는지 결정할 수 없으며 파일 이름은 많은 경우 의미가 없는 숫자 및 문자의 문자열이며 콘텐츠 또는 의미를 설명하지 않습니다."
  },
  "screen_readers_cannot_determine_what_is_displayed__6f1ea667": {
    "message": "화면 읽기 프로그램은 이미지의 콘텐츠 및 의미를 설명하는 대체 텍스트가 없는 이미지에서 표시하는 것을 결정할 수 없습니다. 대체 텍스트는 단순하며 간략해야 합니다."
  },
  "screen_readers_cannot_determine_what_is_displayed__a57e6723": {
    "message": "화면 읽기 프로그램은 이미지의 콘텐츠 및 의미를 설명하는 대체 텍스트가 없는 이미지에서 표시하는 것을 결정할 수 없습니다."
  },
  "screen_readers_cannot_interpret_tables_without_the_bd861652": {
    "message": "화면 읽기 프로그램은 적절한 구조가 없는 표를 해석할 수 없습니다. 표 헤더는 방향 및 콘텐츠 범위를 제공합니다."
  },
  "screen_readers_cannot_interpret_tables_without_the_e62912d5": {
    "message": "화면 읽기 프로그램은 적절한 구조가 없는 표를 해석할 수 없습니다. 표 캡션은 표의 컨텍스트 및 일반 이해를 설명합니다."
  },
  "screen_readers_cannot_interpret_tables_without_the_f0bdec0f": {
    "message": "화면 읽기 프로그램은 적절한 구조가 없는 표를 해석할 수 없습니다. 표 헤더는 콘텐츠의 방향 및 범위를 제공합니다."
  },
  "script_l_42a7b254": {
    "message": "스크립트 L"
  },
  "search_280d00bd": {
    "message": "검색"
  },
  "select_audio_source_21043cd5": {
    "message": "오디오 소스 선택"
  },
  "select_crop_shape_d441feeb": {
    "message": "자르기 도형 선택"
  },
  "select_language_7c93a900": {
    "message": "언어 선택"
  },
  "select_video_source_1b5c9dbe": {
    "message": "동영상 소스 선택"
  },
  "selected_274ce24f": {
    "message": "선택됨"
  },
  "selected_linkfilename_c093b1f2": {
    "message": "{ linkFileName } 선택됨"
  },
  "selection_b52c4c5e": {
    "message": "선택"
  },
  "set_header_scope_8c548f40": {
    "message": "헤더 범위 설정"
  },
  "set_minus_b46e9b88": {
    "message": "빼기 설정"
  },
  "set_table_header_cfab13a0": {
    "message": "표 헤더 설정"
  },
  "sharp_music_ab956814": {
    "message": "반음 올림(음악)"
  },
  "shift_arrows_4d5785fe": {
    "message": "SHIFT+화살표"
  },
  "shift_o_to_open_the_pretty_html_editor_55ff5a31": {
    "message": "Shift-O키로 pretty html 편집기를 시작합니다."
  },
  "shortcut_911d6255": {
    "message": "바로 가기"
  },
  "show_image_options_1e2ecc6b": {
    "message": "이미지 옵션 표시"
  },
  "show_link_options_545338fd": {
    "message": "링크 옵션 표시"
  },
  "show_rolling_transcript_c1481744": {
    "message": "롤링 대화 내용 표시"
  },
  "show_rolling_transcript_d353aca4": {
    "message": "롤링 대화 내용 표시"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_1d4db0c1": {
    "message": "시력에 문제가 없는 사용자는 큰 머리글 또는 굵은 글자체의 머리글을 찾아서 웹 페이지를 빠르게 탐색합니다. 화면 읽기 프로그램 사용자는 컨텍스트에 기반한 이해를 위해 헤더에 의존합니다. 헤더는 적절한 구조를 사용해야 합니다."
  },
  "sighted_users_browse_web_pages_quickly_looking_for_ade806f5": {
    "message": "시력에 문제가 없는 사용자는 큰 머리글 또는 굵은 글자체의 머리글을 찾아서 웹 페이지를 빠르게 탐색합니다. 화면 읽기 프로그램 사용자는 컨텍스트에 기반한 이해를 위해 헤더에 의존합니다. 헤더는 적절한 구조 내에서 간략해야 합니다."
  },
  "sigma_5c35e553": {
    "message": "시그마"
  },
  "sigma_variant_8155625": {
    "message": "스그마(변형)"
  },
  "single_color_image_4e5d4dbc": {
    "message": "단일 색 이미지"
  },
  "single_color_image_color_95fa9a87": {
    "message": "단일 색 이미지 색"
  },
  "size_b30e1077": {
    "message": "크기"
  },
  "size_of_caption_file_is_greater_than_the_maximum_m_bff5f86e": {
    "message": "캡션 파일의 크기가 최대 허용된 파일 크기 { max }KB보다 큽니다."
  },
  "small_b070434a": {
    "message": "작은"
  },
  "small_width_x_height_px_359acd38": {
    "message": "작게({ width } x { height }px)"
  },
  "solid_circle_9f061dfc": {
    "message": "채워진 원"
  },
  "something_went_wrong_89195131": {
    "message": "문제가 발생했습니다."
  },
  "something_went_wrong_accessing_your_webcam_6643b87e": {
    "message": "웹캠에 액세스하는 데 문제가 발생했습니다."
  },
  "something_went_wrong_and_i_don_t_know_what_to_show_e0c54ec8": {
    "message": "문제가 발생하여 무엇을 표시해야 하는지 모르겠습니다."
  },
  "something_went_wrong_check_your_connection_reload__c7868286": {
    "message": "문제가 발생했습니다. 연결을 확인하고 페이지를 다시 로드하고 다시 시도하세요."
  },
  "something_went_wrong_d238c551": {
    "message": "문제가 발생했습니다"
  },
  "something_went_wrong_while_sharing_your_screen_8de579e5": {
    "message": "화면을 공유하는 동안 문제가 발생했습니다."
  },
  "sort_by_e75f9e3e": {
    "message": "정렬 기준"
  },
  "spades_suit_b37020c2": {
    "message": "스페이드(슈트)"
  },
  "square_511eb3b3": {
    "message": "사각"
  },
  "square_cap_9ec88646": {
    "message": "교집합"
  },
  "square_cup_b0665113": {
    "message": "합집합"
  },
  "square_root_e8bcbc60": {
    "message": "제곱근"
  },
  "square_root_symbol_d0898a53": {
    "message": "제곱근 기호"
  },
  "square_subset_17be67cb": {
    "message": "스퀘어 부분집합"
  },
  "square_subset_strict_7044e84f": {
    "message": "스퀘어 부분집합(진부분)"
  },
  "square_superset_3be8dae1": {
    "message": "스퀘어 초집합"
  },
  "square_superset_strict_fa4262e4": {
    "message": "스퀘어 초집합(진초집합)"
  },
  "square_unordered_list_b15ce93b": {
    "message": "사각 순서가 지정되지 않은 목록"
  },
  "star_8d156e09": {
    "message": "별표 표시"
  },
  "start_over_f7552aa9": {
    "message": "새로 시작"
  },
  "start_recording_9a65141a": {
    "message": "녹화 시작"
  },
  "steel_blue_14296f08": {
    "message": "강청색"
  },
  "studio_media_options_ee504361": {
    "message": "Studio 미디어 옵션"
  },
  "studio_media_options_tray_cfb94654": {
    "message": "Studio 미디어 옵션 트레이"
  },
  "styles_2aa721ef": {
    "message": "스타일"
  },
  "submit_a3cc6859": {
    "message": "제출"
  },
  "submitting_b90fac62": {
    "message": "제출 중..."
  },
  "subscript_59744f96": {
    "message": "아래 첨자"
  },
  "subset_19c1a92f": {
    "message": "부분 집합"
  },
  "subset_strict_8d8948d6": {
    "message": "부분 집합(진부분)"
  },
  "succeeds_9cc31be9": {
    "message": "후행"
  },
  "succeeds_equal_158e8c3a": {
    "message": "후행 또는 동등"
  },
  "sum_b0842d31": {
    "message": "합계"
  },
  "superscript_8cb349a2": {
    "message": "위 첨자"
  },
  "superscript_and_subscript_37f94a50": {
    "message": "위 첨자 및 아래 첨자"
  },
  "superset_c4db8a7a": {
    "message": "초집합"
  },
  "superset_strict_c77dd6d2": {
    "message": "초집합(진초집합)"
  },
  "supported_file_types_srt_or_webvtt_7d827ed": {
    "message": "지원하는 파일 유형: SRT 또는 WebVTT"
  },
  "switch_to_pretty_html_editor_a3cee15f": {
    "message": "Pretty HTML 편집기로 전환"
  },
  "switch_to_raw_html_editor_f970ae1a": {
    "message": "원시 HTML 편집기로 전환"
  },
  "switch_to_the_html_editor_146dfffd": {
    "message": "HTML 편집기로 전환"
  },
  "switch_to_the_rich_text_editor_63c1ecf6": {
    "message": "서식이 있는 텍스트 편집기로 전환"
  },
  "syllabus_f191f65b": {
    "message": "강의 계획안"
  },
  "system_audio_allowed_b2508f8c": {
    "message": "시스템 오디오 허용됨"
  },
  "system_audio_disabled_c177bd13": {
    "message": "시스템 오디오 사용 안 함"
  },
  "tab_arrows_4cf5abfc": {
    "message": "TAB/화살표"
  },
  "table_header_starting_with_start_ffcabba6": {
    "message": "{ start }(으)로 시작되는 표 헤더"
  },
  "table_starting_with_start_e7232848": {
    "message": "{ start }(으)로 시작되는 표"
  },
  "tables_headers_should_specify_scope_5abf3a8e": {
    "message": "표 헤더는 범위를 지정해야 합니다."
  },
  "tables_should_include_a_caption_describing_the_con_e91e78fc": {
    "message": "표에는 표의 콘텐츠를 설명하는 캡션이 포함되어야 합니다."
  },
  "tables_should_include_at_least_one_header_48779eac": {
    "message": "표는 적어도 하나의 헤더를 포함해야 합니다."
  },
  "tau_880974b7": {
    "message": "타우"
  },
  "teal_f729a294": {
    "message": "청록색"
  },
  "text_7f4593da": {
    "message": "텍스트"
  },
  "text_background_color_16e61c3f": {
    "message": "텍스트 배경 색"
  },
  "text_color_acf75eb6": {
    "message": "텍스트 색"
  },
  "text_is_difficult_to_read_without_sufficient_contr_69e62bd6": {
    "message": "텍스트는 특히 시력이 낮은 사용자에게 텍스트와 배경 간에 대비가 충분하지 않으면 읽기 힘듭니다."
  },
  "text_larger_than_18pt_or_bold_14pt_should_display__5c364db6": {
    "message": "18pt(또는 굵게 14pt)보다 큰 텍스트는 최소 3:1 비율의 대비로 표시되어야 합니다."
  },
  "text_optional_384f94f7": {
    "message": "텍스트(선택 사항)"
  },
  "text_position_8df8c162": {
    "message": "텍스트 위치"
  },
  "text_size_887c2f6": {
    "message": "텍스트 크기"
  },
  "text_smaller_than_18pt_or_bold_14pt_should_display_aaffb22b": {
    "message": "18pt(또는 굵게 14pt)보다 작은 텍스트는 최소 4.5:1 비율의 대비로 표시되어야 합니다."
  },
  "the_document_preview_is_currently_being_processed__7d9ea135": {
    "message": "문서 미리 보기를 현재 처리 중입니다. 나중에 다시 시도하세요."
  },
  "the_first_heading_on_a_page_should_be_an_h2_859089f2": {
    "message": "페이지의 첫 번째 머리글은 H2여야 합니다."
  },
  "the_height_of_rich_content_area_is_decreased_36920e0": {
    "message": "서식 있는 콘텐츠 영역의 높이가 줄었습니다."
  },
  "the_height_of_rich_content_area_is_increased_74c2358d": {
    "message": "서식 있는 콘텐츠 영역의 높이가 늘었습니다."
  },
  "the_material_is_in_the_public_domain_279c39a3": {
    "message": "자료는 공개 도메인에 속합니다"
  },
  "the_material_is_licensed_under_creative_commons_3242cb5e": {
    "message": "자료는 Creative Commons에 따라 라이선스가 부여되었습니다"
  },
  "the_material_is_subject_to_an_exception_e_g_fair_u_a39c8ca2": {
    "message": "자료에는 예외가 적용됩니다. 예, 공정한 사용, 인용 권리 또는 관련 저작권 법에 따른 기타 권리"
  },
  "the_pretty_html_editor_is_not_keyboard_accessible__d6d5d2b": {
    "message": "아쉽게도 Pretty HTML 편집기는 키보드로 액세스할 수 없습니다. Shift O키를 눌러서 pretty html 편집기를 시작합니다."
  },
  "therefore_d860e024": {
    "message": "따라서"
  },
  "theta_ce2d2350": {
    "message": "세타"
  },
  "theta_variant_fff6da6f": {
    "message": "세타(변형)"
  },
  "thick_downward_arrow_b85add4c": {
    "message": "두꺼운 아래쪽 화살"
  },
  "thick_left_arrow_d5f3e925": {
    "message": "두꺼운 왼쪽 화살"
  },
  "thick_leftward_arrow_6ab89880": {
    "message": "두꺼운 왼쪽으로 향한 화살"
  },
  "thick_right_arrow_3ed5e8f7": {
    "message": "두꺼운 오른쪽 화살"
  },
  "thick_rightward_arrow_a2e1839e": {
    "message": "두꺼운 오른쪽을 향한 화살"
  },
  "thick_upward_arrow_acd20328": {
    "message": "두꺼운 위로 향한 화살"
  },
  "this_document_cannot_be_displayed_within_canvas_7aba77be": {
    "message": "이 문서는 Canvas 내에 표시할 수 없습니다."
  },
  "this_equation_cannot_be_rendered_in_basic_view_9b6c07ae": {
    "message": "이 방정식은 기본 보기에서 렌더링할 수 없습니다."
  },
  "this_image_is_currently_unavailable_25c68857": {
    "message": "이 이미지는 현재 사용할 수 없습니다"
  },
  "this_video_may_display_youtube_ads_4d19d590": {
    "message": "이 동영상은 YouTube 광고를 표시할 수 있습니다."
  },
  "though_your_video_will_have_the_correct_title_in_t_90e427f3": {
    "message": "동여상은 브라우저에서 정확한 제목을 표시할 것이지만 데이터베이스에서 업데이트하지 못했습니다."
  },
  "thumbnail_e0de666f": {
    "message": "썸네일"
  },
  "timebar_a4d18443": {
    "message": "시간 표시줄"
  },
  "title_can_t_be_blank_eb4021d7": {
    "message": "제목은 비어 있을 수 없습니다"
  },
  "title_ee03d132": {
    "message": "제목"
  },
  "to_be_posted_when_d24bf7dc": {
    "message": "게시 예정: { when }"
  },
  "to_do_when_2783d78f": {
    "message": "할 일: { when }"
  },
  "toggle_summary_group_413df9ac": {
    "message": "{ summary } 그룹을 토글"
  },
  "toggle_tooltip_d3b7cb86": {
    "message": "도구 설명 토글"
  },
  "tools_2fcf772e": {
    "message": "도구"
  },
  "top_66e0adb6": {
    "message": "상단"
  },
  "transcript_panel_is_available_at_widths_above_720p_1cf94c0d": {
    "message": "대화 기록 패널은 720px 이상의 너비에서 사용할 수 있습니다."
  },
  "tray_839df38a": {
    "message": "트레이"
  },
  "triangle_6072304e": {
    "message": "삼각형"
  },
  "turnstile_yields_f9e76df1": {
    "message": "함의(산출)"
  },
  "type_control_f9_to_access_image_options_text_a47e319f": {
    "message": "Control F9 키를 눌러서 이미지 옵션에 액세스합니다. { text }"
  },
  "type_control_f9_to_access_link_options_text_4ead9682": {
    "message": "Control F9 키를 눌러서 연결 옵션에 액세스합니다. { text }"
  },
  "type_control_f9_to_access_table_options_text_92141329": {
    "message": "Control F9 키를 눌러서 표 옵션에 액세스합니다. { text }"
  },
  "unable_to_determine_resource_selection_url_7867e060": {
    "message": "자료 선택 URL을 결정할 수 없음"
  },
  "underline_applied_ae01ec97": {
    "message": "밑줄 적용됨"
  },
  "underline_removed_3693e17c": {
    "message": "밑줄 제거됨"
  },
  "union_e6b57a53": {
    "message": "합집합"
  },
  "unpublished_dfd8801": {
    "message": "게시되지 않음"
  },
  "unsaved_changes_will_be_lost_f977252a": {
    "message": "저장되지 않은 변경 사항은 사라집니다."
  },
  "untitled_16aa4f2b": {
    "message": "제목 없음"
  },
  "untitled_efdc2d7d": {
    "message": "제목 없음"
  },
  "up_and_left_diagonal_arrow_e4a74a23": {
    "message": "위 및 왼쪽 대각선 화살표"
  },
  "up_and_right_diagonal_arrow_935b902e": {
    "message": "위 및 오른쪽 대각선 화살표"
  },
  "up_c553575d": {
    "message": "위로"
  },
  "updated_link_a827e441": {
    "message": "업데이트된 링크"
  },
  "upload_document_253f0478": {
    "message": "문서 업로드"
  },
  "upload_file_fd2361b8": {
    "message": "파일 업로드"
  },
  "upload_image_6120b609": {
    "message": "이미지 업로드"
  },
  "upload_media_ce31135a": {
    "message": "미디어 업로드"
  },
  "upload_record_media_e4207d72": {
    "message": "미디어 업로드/녹화"
  },
  "uploading_19e8a4e7": {
    "message": "업로드"
  },
  "uppercase_alphabetic_ordered_list_3f5aa6b2": {
    "message": "대문자 알파벳 순서 목록"
  },
  "uppercase_delta_d4f4bc41": {
    "message": "대문자 델타"
  },
  "uppercase_gamma_86f492e9": {
    "message": "대문자 감마"
  },
  "uppercase_lambda_c78d8ed4": {
    "message": "대문자 람다"
  },
  "uppercase_omega_8aedfa2": {
    "message": "대문자 오메가"
  },
  "uppercase_phi_caa36724": {
    "message": "대문자 파이(Phi)"
  },
  "uppercase_pi_fcc70f5e": {
    "message": "대문자 파이(Pi)"
  },
  "uppercase_psi_6395acbe": {
    "message": "대문자 프사이"
  },
  "uppercase_roman_numeral_ordered_list_853f292b": {
    "message": "대문자 로마 숫자 순서 목록"
  },
  "uppercase_sigma_dbb70e92": {
    "message": "대문자 시그마"
  },
  "uppercase_theta_49afc891": {
    "message": "대문자 세타"
  },
  "uppercase_upsilon_8c1e623e": {
    "message": "대문자 엡실론"
  },
  "uppercase_xi_341e8556": {
    "message": "대문자 크사이"
  },
  "upsilon_33651634": {
    "message": "엡실론"
  },
  "upward_and_downward_pointing_arrow_fa90a918": {
    "message": "위 및 아래 방향 화살표"
  },
  "upward_and_downward_pointing_arrow_thick_d420fdef": {
    "message": "위 및 아래 방향 화살표(두껍게)"
  },
  "upward_arrow_9992cb2d": {
    "message": "위로 향한 화살표"
  },
  "upward_pointing_triangle_d078d7cb": {
    "message": "위 방향 삼각형"
  },
  "url_22a5f3b8": {
    "message": "URL"
  },
  "usage_right_ff96f3e2": {
    "message": "사용 권리:"
  },
  "usage_rights_required_5fe4dd68": {
    "message": "사용 권리(필수)"
  },
  "use_arrow_keys_to_navigate_options_2021cc50": {
    "message": "화살표 키를 사용하여 옵션을 탐색합니다."
  },
  "use_arrow_keys_to_select_a_shape_c8eb57ed": {
    "message": "화살표 키를 사용하여 모양을 선택합니다."
  },
  "use_arrow_keys_to_select_a_size_699a19f4": {
    "message": "화살표 키를 사용하여 크기를 선택합니다."
  },
  "use_arrow_keys_to_select_a_text_position_72f9137c": {
    "message": "화살표 키를 사용하여 텍스트 위치를 선택합니다."
  },
  "use_arrow_keys_to_select_a_text_size_65e89336": {
    "message": "화살표 키를 사용하여 텍스트 크기를 선택합니다."
  },
  "use_arrow_keys_to_select_an_outline_size_e009d6b0": {
    "message": "화살표 키를 사용하여 윤곽 크기를 선택합니다."
  },
  "used_by_screen_readers_to_describe_the_content_of__4f14b4e4": {
    "message": "{ TYPE }의 콘텐츠를 설명하기 위해 화면 읽기 프로그램에서 사용"
  },
  "used_by_screen_readers_to_describe_the_content_of__b1e76d9e": {
    "message": "이미지의 콘텐츠를 설명하기 위해 화면 읽기 프로그램에서 사용"
  },
  "user_documents_c206e61f": {
    "message": "사용자 문서"
  },
  "user_files_78e21703": {
    "message": "사용자 파일"
  },
  "user_images_b6490852": {
    "message": "사용자 이미지"
  },
  "user_media_14fbf656": {
    "message": "사용자 미디어"
  },
  "vector_notation_cf6086ab": {
    "message": "벡터(표기법)"
  },
  "vertical_bar_set_builder_notation_4300495f": {
    "message": "수직 막대(조건제시법)"
  },
  "vertical_dots_bfb21f14": {
    "message": "수직 점"
  },
  "video_options_24ef6e5d": {
    "message": "동영상 옵션"
  },
  "video_options_tray_3b9809a5": {
    "message": "동영상 옵션 트레이"
  },
  "video_player_b371005": {
    "message": "동영상 플레이어"
  },
  "video_player_for_9e7d373b": {
    "message": "다음의 동영상 플레이어 "
  },
  "video_player_for_title_ffd9fbc4": {
    "message": "{ title }의 동영상 플레이어"
  },
  "video_url_889d3263": {
    "message": "동영상 URL"
  },
  "view_all_e13bf0a6": {
    "message": "모두 보기"
  },
  "view_ba339f93": {
    "message": "보기"
  },
  "view_description_30446afc": {
    "message": "설명 보기"
  },
  "view_keyboard_shortcuts_34d1be0b": {
    "message": "키보드 바로 가기 보기"
  },
  "view_title_description_67940918": {
    "message": "{ title } 설명 보기"
  },
  "view_word_and_character_counts_a743dd0c": {
    "message": "단어 및 글자 수 보기"
  },
  "viewer_restrictions_e14274c9": {
    "message": "뷰어 제한"
  },
  "we_couldn_t_detect_a_working_microphone_connected__ceb71c40": {
    "message": "장치에 연결된 작동하는 마이크를 탐지할 수 없습니다."
  },
  "we_couldn_t_detect_a_working_webcam_connected_to_y_6715cc4": {
    "message": "장치에 연결된 작동하는 웹캠을 탐지할 수 없습니다."
  },
  "we_couldn_t_detect_a_working_webcam_or_microphone__263b6674": {
    "message": "장치에 연결된 작동하는 웹캠 또는 마이크를 탐지할 수 없습니다."
  },
  "webcam_disabled_30c66986": {
    "message": "웹캠 사용 안 함"
  },
  "webcam_fe91b20f": {
    "message": "웹캠"
  },
  "webpages_should_only_have_a_single_h1_which_is_aut_dc99189e": {
    "message": "웹 페이지에는 자동으로 페이지의 제목으로 사용되는 하나의 H1만 있어야 합니다. 콘텐츠의 첫 번째 머리글은 H2여야 합니다."
  },
  "when_markup_is_used_that_visually_formats_items_as_f941fc1b": {
    "message": "항목을 목록으로 시각적으로 형식을 지정하는 태그를 사용하지만 목록 관계가 표시되지 않는 경우, 사용자는 정보를 탐색하는 데 어려움이 있을 수 있습니다."
  },
  "white_87fa64fd": {
    "message": "흰색"
  },
  "why_523b3d8c": {
    "message": "이유"
  },
  "width_492fec76": {
    "message": "너비"
  },
  "width_and_height_must_be_numbers_110ab2e3": {
    "message": "너비 및 높이는 숫자여야 합니다"
  },
  "width_x_height_px_ff3ccb93": {
    "message": "{ width }x{ height }px"
  },
  "wiki_home_9cd54d0": {
    "message": "위키 홈"
  },
  "word_count_c77fe3a6": {
    "message": "단어 수"
  },
  "words_b448b7d5": {
    "message": "단어"
  },
  "wreath_product_200b38ef": {
    "message": "화환곱"
  },
  "xi_149681d0": {
    "message": "크사이"
  },
  "yes_dde87d5": {
    "message": "예"
  },
  "you_are_on_a_color_palette_to_navigate_on_the_pale_227fc3a6": {
    "message": "색 팔레크를 이용하고 있습니다. 팔레트에서 위, 왼쪽, 아래 또는 오른쪽으로 탐색하려면 각각 ''W'', ''A'', ''S'' 및 ''D'' 버튼을 사용합니다."
  },
  "you_are_on_a_color_slider_to_navigate_the_slider_l_e800f68a": {
    "message": "색 슬라이더를 이용하고 있습니다. 슬라이더에서 왼쪽 또는 오른쪽으로 탐색하려면 각각 ''A'' 및 ''D'' 버튼을 사용합니다."
  },
  "you_are_on_an_alpha_slider_to_navigate_the_slider__3a014dc5": {
    "message": "알파 슬라이더를 이용하고 있습니다. 슬라이더에서 왼쪽 또는 오른쪽으로 탐색하려면 각각 ''A'' 및 ''D'' 버튼을 사용합니다."
  },
  "you_have_unsaved_changes_in_the_icon_maker_tray_do_e8cf5f1b": {
    "message": "아이콘 메이커 트레이에 저장되지 않은 변경 사항이 있습니다. 변경 사항을 저장하지 않고 계속하시겠습니까?"
  },
  "you_may_need_to_adjust_additional_headings_to_main_975f0eee": {
    "message": "페이지 계층 구조를 유지하려면 추가적 머리글을 조정해야 합니다."
  },
  "you_may_not_upload_an_empty_file_11c31eb2": {
    "message": "빈 파일을 업로드할 수 없습니다."
  },
  "your_image_has_been_compressed_for_icon_maker_imag_2e45cd91": {
    "message": "이미지를 아이콘 메이커 용도로 압축했습니다. { size }KB 미만의 이미지는 압축하지 않습니다."
  },
  "your_microphone_is_blocked_in_the_browser_settings_42af0ddc": {
    "message": "마이크가 브라우저 설정에서 차단되어 있습니다."
  },
  "your_webcam_and_microphone_are_blocked_in_the_brow_73357dc6": {
    "message": "웹캡 및 마이크가 브라우저 설정에서 차단되어 있습니다."
  },
  "your_webcam_is_blocked_in_the_browser_settings_7f638128": {
    "message": "웹캠이 브라우저 설정에서 차단되어 있습니다."
  },
  "your_webcam_may_already_be_in_use_6cd64c25": {
    "message": "웹캠이 이미 사용 중일 수 있습니다."
  },
  "youtube_embed_url_5c1018d4": {
    "message": "YouTube 포함 URL"
  },
  "zeta_5ef24f0e": {
    "message": "제타"
  },
  "zoom_f3e54d69": {
    "message": "확대/축소"
  },
  "zoom_in_image_bb97d4f": {
    "message": "이미지 확대"
  },
  "zoom_out_image_d0a0a2ec": {
    "message": "이미지 축소"
  }
};
formatMessage.addLocale({
  ko: locale
});